export const getTitle = (title: string) => {
  return title + " - " + import.meta.env.VITE_WEBSITE_NAME;
};

/**
 * Format number to VND.
 * Example: formatVND(10000);           // '10.000'
 */
export function formatVND(num: number) {
  return `${num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
}
